const requestState = {
    initial: 'initial',
    serverError: 'serverError',
    internetConnection: 'internetConnection',
    haveData: 'haveData',
    invalidTokne: 'invalidToken',
}
const StepScreenEnum = {
    doesNotHave: 'doesNotHave',
    Create: 'Create',
    HaveCreated: 'HaveCreated',
}
const domainType = {
    theory: 'Theory',
    communication: 'Communication',
}
const settingsSlick = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
};
function shortenText(text, maxLength) {
    if (text.length > maxLength) {
        return text.substring(0, maxLength - 3) + "...";
    } else {
        return text;
    }
}

/**
 * Formats problem_identifyed_from_event for display.
 * Handles both old string format and new 3-level hierarchical structure.
 * @param {string|Array|null|undefined} problemData - The problem data from the API
 * @returns {string} - A formatted string for display
 */
function formatProblemDisplay(problemData) {
    // Handle null/undefined
    if (!problemData) {
        return '';
    }

    // Handle plain string (old format)
    if (typeof problemData === 'string') {
        return problemData;
    }

    // Handle array format (new 3-level structure)
    if (Array.isArray(problemData)) {
        const problems = [];
        
        for (const item of problemData) {
            // Handle string items in array (simple array of strings)
            if (typeof item === 'string') {
                problems.push(item);
                continue;
            }
            
            // Handle object items (new hierarchical structure)
            if (item && typeof item === 'object') {
                // Get main problem text
                if (item.problem) {
                    problems.push(item.problem);
                }
                
                // Get sub-problems if they exist
                if (Array.isArray(item.sub_problems)) {
                    for (const subItem of item.sub_problems) {
                        // Handle string sub-problems (old 2-level format)
                        if (typeof subItem === 'string') {
                            problems.push(subItem);
                        }
                        // Handle object sub-problems (new 3-level format)
                        else if (subItem && typeof subItem === 'object' && subItem.sub_problem) {
                            problems.push(subItem.sub_problem);
                        }
                    }
                }
            }
        }
        
        return problems.join(', ');
    }

    // Fallback: try to convert to string
    return String(problemData);
}
const youtubeRegex = /https:\/\/youtu\.be\/([a-zA-Z0-9_-]{11})(\?.*)?$/;
const extractVideoId = (link) => {
    if (!link) return null;

    // Handle youtu.be links: https://youtu.be/VIDEO_ID
    const youtuBeRegex = /youtu\.be\/([a-zA-Z0-9_-]{11})/;
    const youtuBeMatch = link.match(youtuBeRegex);
    if (youtuBeMatch) {
        return youtuBeMatch[1];
    }

    // Handle youtube.com links: https://www.youtube.com/watch?v=VIDEO_ID
    const youtubeRegex = /(?:youtube\.com\/watch\?v=|youtube\.com\/embed\/|youtube\.com\/v\/)([a-zA-Z0-9_-]{11})/;
    const youtubeMatch = link.match(youtubeRegex);
    if (youtubeMatch) {
        return youtubeMatch[1];
    }

    // If link already looks like just an ID
    if (/^[a-zA-Z0-9_-]{11}$/.test(link)) {
        return link;
    }

    return null;
};
export { requestState, StepScreenEnum, domainType, settingsSlick, shortenText, formatProblemDisplay, youtubeRegex, extractVideoId };